export default __webpack_public_path__ + "static/media/emailpage.3f3faf09.svg";